import { camelToSnakeCase, snakeToCamelCase } from './text';

export const objectPropsToSnakeCase = (object) => {
  return convertProps(camelToSnakeCase, object);
};

export const objectPropsToCamelCase = (object) => {
  return convertProps(snakeToCamelCase, object);
};

const convertProps = (conversionMethod, object = {}) => {
  if (object === null) {
    return {};
  }

  if (Array.isArray(object)) {
    return object;
  }

  return Object.keys(object).reduce((acc, prop) => {
    const value = object[prop];

    if (isObject(value)) {
      acc[conversionMethod(prop)] = convertProps(conversionMethod, value);
    } else {
      acc[conversionMethod(prop)] = value;
    }

    return acc;
  }, {});
};

const isObject = (object) => object && object.constructor === Object;
